import links from '@/constants/links';

export default {
    mainMenu: {
        logged: [],
        loggedAdmin: [],
        loggedCompleted: [{
                icon: "fal fa-user-circle",
                text: "components.menu.profile",
                to: links.routes.profileOverview
            },
            {
                icon: "fal fa-newspaper",
                text: "components.menu.newsfeed",
                to: links.routes.welcome
            },
            {
                icon: "fal fa-store-alt",
                text: "components.menu.buy",
                to: links.routes.checkout.replace('/:id', '').replace('/:provider', '')
            },
            // {
            //     icon: "fal fa-brands fa-shopify",
            //     text: "components.menu.physicalShop",
            //     to: links.routes.shopPhysical,
            //     redirect: true,
            // },
            {
                icon: "fal fa-brands fa-shopify",
                text: "components.menu.tasteTravellersShop",
                to: links.routes.shopTasteTravellers,
                redirect: true,
            },
            {
                icon: "fal fa-store",
                text: "components.menu.shop",
                to: links.routes.shopPopular.replace(':packId?', '')
            },
            {
                icon: "fal fa-brands fa-paypal",
                text: "components.menu.donate",
                to: "https://www.paypal.com/donate/?hosted_button_id=DNE9M6HBGPSKY",
                redirect: true,
            },
            // {
            //     icon: "fal fa-gifts",
            //     text: "components.menu.send",
            //     to: links.routes.giftPoints
            // },
            {
                icon: "fal fa-calendar-star",
                text: "components.menu.events",
                to: links.routes.events
            },
            {
                icon: "fal fa-sticky-note",
                text: "components.menu.notes",
                to: links.routes.notes
            },
            {
                icon: "fal fa-info-square",
                text: "components.menu.guides",
                to: links.routes.guides
            },
        ],
        guest: [{
                icon: "fal fa-newspaper",
                text: "components.menu.newsfeed",
                to: links.routes.welcome
            },
            {
                icon: "fal fa-sign-in",
                text: "components.menu.login",
                to: links.routes.login
            },
            {
                icon: "fal fa-gamepad",
                text: "components.menu.register",
                to: links.routes.register.replace(':referral', '')
            },
            // {
            //     icon: "fal fa-brands fa-shopify",
            //     text: "components.menu.physicalShop",
            //     to: links.routes.shopPhysical,
            //     redirect: true,
            // },
            {
                icon: "fal fa-brands fa-shopify",
                text: "components.menu.tasteTravellersShop",
                to: links.routes.shopTasteTravellers,
                redirect: true,
            },
            {
                icon: "fal fa-store",
                text: "components.menu.shop",
                to: links.routes.shopPopular.replace(':packId?', '')
            },
            {
                icon: "fal fa-brands fa-paypal",
                text: "components.menu.donate",
                to: links.communities.directDonate,
                redirect: true,
            },
            {
                icon: "fal fa-calendar-star",
                text: "components.menu.events",
                to: links.routes.events
            },
            {
                icon: "fal fa-sticky-note",
                text: "components.menu.notes",
                to: links.routes.notes
            },
            {
                icon: "fal fa-info-square",
                text: "components.menu.guides",
                to: links.routes.guides
            },
            {
                icon: "fal fa-lock-alt",
                text: "components.menu.reset",
                to: links.routes.resetLink
            },
        ]
    },
}
